import _mixin from '../_mixin'

export default {
  name: 'SVersionBuy',
  cnName: '购买按钮类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: 'ZSONBQR6QORQ72BXPBPZ7TXYRE',
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/69dc3d21932729a7150639b8bf68911a.jpg',
      style: {
        width: '1920px',
        height: '1058px'
      }
    },
    btnBuy: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/cc9ca93c71695b13b3d815ae4ec0220b.png',
      style: {
        width: '452px',
        height: '125px',
        position: "absolute",
        top: '',
        right: '',
        bottom: '220px',
        left: '861px'
      }
    }
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnBuy',
      label: '购买按钮图片',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
